let queue = [];
let isRunning = false;
const INTERVAL = 500; // 2 requests per second

const runQueue = () => {
  if (queue.length === 0) {
    isRunning = false;
    return;
  }

  isRunning = true;

  const next = queue.shift();
  next();

  setTimeout(runQueue, INTERVAL);
};

export const enqueueRequest = (fn) => {
  queue.push(fn);

  if (!isRunning) {
    runQueue();
  }
};
